import React from "react";
import ReactDom from "react-dom";
import App from "./App";
import "@common/common.less";

const container = document.getElementById("App");

ReactDom.render(<App />, container);
